import React from "react";
import "./FooterMiddle.scss";
import Wrapper from "../../Common/Wrapper";

const FooterMiddle = ({ themeOptions }) => {
    const { tel_1, tel_2, email, address, header_logo } = themeOptions;
    const { url, alt, width, height, title } = header_logo || {};
    const homeUrl = window.themeSettings?.homeUrl || "/";

    return (
        <div className="footer--middle">
            <Wrapper>
                <div className="footer--middle__inside">
                    <div className="footer--middle__inside--left">
                        {url && (
                            <a href={homeUrl} rel="nofollow">
                                <img
                                    src={url}
                                    alt={alt || "Logo"}
                                    width={width}
                                    height={height}
                                    title={title}
                                />
                            </a>
                        )}
                    </div>
                    <div className="footer--middle__inside--right">
                        {tel_1 && (
                            <div className="single-contact-data">
                                <span className="single-contact-data--icon phone-icon"></span>
                                <a href={`tel:${tel_1}`} className="single-contact-data--text">
                                    {tel_1}
                                </a>
                            </div>
                        )}
                        {tel_2 && (
                            <div className="single-contact-data">
                                <span className="single-contact-data--icon phone-icon"></span>
                                <a href={`tel:${tel_2}`} className="single-contact-data--text">
                                    {tel_2}
                                </a>
                            </div>
                        )}
                        {email && (
                            <div className="single-contact-data">
                                <span className="single-contact-data--icon envelope-icon"></span>
                                <a href={`mailto:${email}`} className="single-contact-data--text">
                                    {email}
                                </a>
                            </div>
                        )}
                        {address && (
                            <div className="single-contact-data map-marker-icon">
                                <span className="single-contact-data--text">{address}</span>
                            </div>
                        )}
                    </div>
                </div>
            </Wrapper>
        </div>
    );
};

export default FooterMiddle;
